var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconVision(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "98px",
    height: "98px",
    viewBox: "0 0 98 98",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "focus") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "About-Us---Desktop-",
    transform: "translate(-790.000000, -1062.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Why-Work",
    transform: "translate(0.000000, 869.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-2",
    transform: "translate(290.000000, 79.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Visie",
    transform: "translate(460.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "focus",
    transform: "translate(40.000000, 114.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.0828434,50.9794367 L94,49.5 L93.0828434,48.0198258 C92.9291134,47.7727614 89.2395921,41.8874654 82.0717418,35.9896315 C72.5382396,28.1462576 61.3069907,24 49.5914172,24 C37.8788288,24 26.619968,28.144045 17.0319887,35.9837314 C9.82309393,41.8786151 6.09178194,47.7594863 5.93655936,48.0072883 L5,49.5 L5.93655936,50.9927117 C6.09178194,51.2405137 9.82309393,57.1213849 17.0319887,63.0162686 C26.619968,70.855955 37.8788288,75 49.5914172,75 C61.3069907,75 72.5382396,70.8537424 82.0717418,63.0103685 C89.2395921,57.1125346 92.9291134,51.2272386 93.0828434,50.9794367 L93.0828434,50.9794367 Z M78.2523708,58.7815102 C69.6763233,65.7848652 60.0331207,69.3352181 49.5914172,69.3352181 C39.1459825,69.3352181 29.4714366,65.7826528 20.8371807,58.7748727 C16.3715465,55.1507694 13.34396,51.4809406 11.8611366,49.5 C13.3447062,47.5175845 16.3722927,43.8484931 20.8371807,40.2243898 C29.4714366,33.2173472 39.1452361,29.6640444 49.5914172,29.6640444 C60.0331207,29.6640444 69.6755771,33.2151348 78.2523708,40.2177523 C82.697856,43.8477557 85.6993233,47.522747 87.1619976,49.5 C85.6978307,51.4779904 82.6971096,55.1529818 78.2523708,58.7815102 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,32 C39.6262026,32 32,39.6262026 32,49 C32,58.3737974 39.6262026,66 49,66 C58.3737974,66 66,58.3737974 66,49 C66,39.6262026 58.3737974,32 49,32 Z M49,60.3416832 C42.7463812,60.3416832 37.6583168,55.2536188 37.6583168,49 C37.6583168,42.7463812 42.7463812,37.6583168 49,37.6583168 C55.2536188,37.6583168 60.3416832,42.7463812 60.3416832,49 C60.3416832,55.2536188 55.2536188,60.3416832 49,60.3416832 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "5.82995951 5.57377049 18 5.57377049 18 0 0 0 0 17 5.82995951 17"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "80 0 80 5.57377049 92.1700405 5.57377049 92.1700405 17 98 17 98 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "5.82995951 81 0 81 0 98 18 98 18 92.4262295 5.82995951 92.4262295"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "92.1700405 92.4262295 80 92.4262295 80 98 98 98 98 81 92.1700405 81"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVision);
export default __webpack_public_path__ + "static/media/icon-vision.32217791e89e182ea2e211b8c6a6c7fc.svg";
export { ForwardRef as ReactComponent };